// Paleta do chat interno: a mesma da conversa de atendimento (components/MessagesList),
// no padrão do WhatsApp Web. É fixa de propósito — não segue a cor da marca.
export const getWa = (isDark) => {
  const wa = isDark
    ? {
        bg: "#0b141a",
        strip: "#202c33",
        field: "#2a3942",
        incoming: "#202c33",
        outgoing: "#005c4b",
        text: "#e9edef",
        meta: "rgba(233,237,239,0.6)",
        icon: "#aebac1",
        pill: "#182229",
        pillText: "#8696a0",
        quote: "rgba(11,20,26,0.35)",
        hover: "#202c33",
        selected: "#2a3942",
        chip: "#202c33",
        chipText: "#8696a0",
        chipOn: "#0a332c",
        chipOnText: "#00a884",
        unread: "#00a884",
        unreadText: "#111b21",
        accent: "#00a884",
        emptyBg: "#222e35",
        doodle: "%23ffffff",
        doodleOpacity: "0.03",
      }
    : {
        bg: "#efeae2",
        strip: "#f0f2f5",
        field: "#ffffff",
        incoming: "#ffffff",
        outgoing: "#d9fdd3",
        text: "#111b21",
        meta: "#667781",
        icon: "#54656f",
        pill: "#ffffff",
        pillText: "#54656f",
        quote: "rgba(11,20,26,0.06)",
        hover: "#f5f6f6",
        selected: "#f0f2f5",
        chip: "#f0f2f5",
        chipText: "#54656f",
        chipOn: "#d9fdd3",
        chipOnText: "#008069",
        unread: "#25d366",
        unreadText: "#ffffff",
        accent: "#00a884",
        emptyBg: "#f0f2f5",
        doodle: "%23000000",
        doodleOpacity: "0.032",
      };
  return {
    ...wa,
    shadow: "0 1px 0.5px rgba(11,20,26,0.13)",
    // papel de parede: desenhos de traço fino, bem apagados, em mosaico
    wallpaper: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180' fill='none' stroke='${wa.doodle}' stroke-opacity='${wa.doodleOpacity}' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M18 26h22a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H30l-8 7v-7h-4a6 6 0 0 1-6-6V32a6 6 0 0 1 6-6z'/%3E%3Ccircle cx='112' cy='30' r='11'/%3E%3Cpath d='M107 30h10M112 25v10'/%3E%3Cpath d='M150 70l6 12 13 2-9 9 2 13-12-6-12 6 2-13-9-9 13-2z'/%3E%3Cpath d='M22 104c8-10 20-10 28 0s20 10 28 0'/%3E%3Crect x='96' y='98' width='26' height='20' rx='4'/%3E%3Cpath d='M96 103l13 9 13-9'/%3E%3Cpath d='M34 146a10 10 0 1 0 14 14'/%3E%3Cpath d='M30 142l5 5M56 166l-5-5'/%3E%3Cpath d='M92 150h30M92 158h20M92 166h26'/%3E%3Cpath d='M150 140v24M138 152h24'/%3E%3Cpath d='M70 62c0-8 12-8 12 0 0 6-6 8-6 14M76 84v.5'/%3E%3C/svg%3E")`,
  };
};

// Cor do nome de quem escreveu, em conversas de grupo (uma por pessoa, estável).
const NAME_COLORS_LIGHT = ["#1f7aec", "#c2410c", "#7c3aed", "#0f766e", "#be185d", "#4d7c0f", "#b45309", "#0e7490"];
const NAME_COLORS_DARK = ["#53bdeb", "#ffa97a", "#a695e7", "#06cf9c", "#f28bc1", "#a3d977", "#f0c060", "#7fd6e4"];

export const senderColor = (senderId, isDark) => {
  const palette = isDark ? NAME_COLORS_DARK : NAME_COLORS_LIGHT;
  const n = Math.abs(parseInt(senderId, 10) || 0);
  return palette[n % palette.length];
};
